import { getLatLng, MapMarker } from '../../common';
import { DealerStore } from '../dealerStoreType';

interface RenderMapMarkerProps {
  id: string | number;
  latitude: number;
  longitude: number;
  isActiveStore: boolean;
  showMarkerDetails: boolean;
  handleActiveMarker: (store?: DealerStore) => void;
  store: DealerStore;
  storeIconElement: Node;
  storeZIndex: number;
  markerInfoOptions?: { minWidth: number; maxWidth: number };
  isUpdatedMapPin?: boolean;
  children?: React.ReactNode;
}

export const RenderMapMarker: React.FC<RenderMapMarkerProps> = ({
  id,
  latitude,
  longitude,
  isActiveStore,
  showMarkerDetails,
  handleActiveMarker,
  store,
  storeIconElement,
  storeZIndex,
  markerInfoOptions,
  isUpdatedMapPin = false,
  children
}) => {
  return (
    <MapMarker
      key={id}
      data-testid={`map-marker-${id}`}
      position={getLatLng(latitude, longitude)}
      showInfo={isActiveStore && showMarkerDetails}
      onClick={() => handleActiveMarker(store)}
      content={storeIconElement}
      zIndex={storeZIndex}
      markerInfoOptions={markerInfoOptions}
      isUpdatedMapPin={isUpdatedMapPin}
    >
      {children}
    </MapMarker>
  );
};
